
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "HPV_associated_oropharyngeal_cancer",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/HPV_associated_oropharyngeal_cancer.vue